/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import store from '../state/store';

store.on('ui:tutor_smser:send', function() {
  const tutor_smser_ui = store.get().ui.tutor_smser;

  const params = {
    tutor_id: tutor_smser_ui.tutor_id,
    tutoring_job_id: tutor_smser_ui.tutoring_job_id,
    content: tutor_smser_ui.content
  };

  return $.ajax({
    url: `/api/sales/tutors/${params.tutor_id}/sms`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      toastr.success('Sms sent!');

      return store.get().ui.set({
        tutor_smser: {
          tutor_id: '',
          tutoring_job_id: '',
          content: ''
        }
      });
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}